import type { CustomerAreaNavItem } from './customerAreaLayoutTypes'
import { joinClassNames } from './customerAreaNavShared'

type CustomerAreaMobileNavigationProps = {
  navItems: CustomerAreaNavItem[]
  activeNavId: string
  onNavigate: (targetPath: string) => void
}

export const CustomerAreaMobileNavigation = ({
  navItems,
  activeNavId,
  onNavigate,
}: CustomerAreaMobileNavigationProps) => (
  <nav className="lg:hidden">
    <div className="flex gap-2 overflow-x-auto pb-1">
      {navItems.map((item) => {
        const active = item.id === activeNavId
        return (
          <button
            key={item.id}
            type="button"
            aria-current={active ? 'page' : undefined}
            onClick={() => onNavigate(item.href)}
            className={joinClassNames(
              'ca-theme-transition inline-flex shrink-0 items-center gap-2 rounded-[10px] border px-3 py-1.5 text-sm font-semibold',
              active
                ? 'border-(--color-action-primary) bg-(--color-action-primary) text-(--color-action-primary-foreground)'
                : 'border-(--color-border-default) bg-(--color-bg-card) text-(--color-text-secondary) hover:border-(--color-border-strong) hover:text-(--color-text-primary)',
            )}
          >
            <span>{item.label}</span>
            {item.badge ? (
              <span
                className={joinClassNames(
                  'rounded-full px-2 py-0.5 text-[11px] font-semibold',
                  active
                    ? 'bg-[color-mix(in_srgb,var(--color-action-primary-foreground)_18%,transparent)] text-(--color-action-primary-foreground)'
                    : 'bg-(--color-bg-surface-muted) text-(--color-text-secondary)',
                )}
              >
                {item.badge}
              </span>
            ) : null}
          </button>
        )
      })}
    </div>
  </nav>
)
